import { Link } from '@inertiajs/react';
import Comment from '@/Components/Comment';
import CommentForm from './CommentForm';

const CommentList = ({ comments, user, letter, is_tmobile }) => {
    return (
        <>
            {(comments.length > 0) && (
                <>
                    <div key="list-{level}" className='px-[10px] md:px-[25px] md:mx-auto md:max-w-[75%] text-[0.8em]'>
                        {letter.disable_comments == false && (
                            <h4 className='text-[1.1em] font-bold'>{ letter.comments.length == 1 ? '1 comment' : `${letter.comments.length} comments`} <a href="#add" className="text-pink">add comment</a></h4>
                        )}
                        {comments.map((comment, index) => (
                            <Comment key={`commentHolder-${comment.id}-${index}`} comment={comment} user={user} />
                        ))}
                    </div>
                </>
            )}
            <CommentForm user={user} letter={letter} is_tmobile={is_tmobile}></CommentForm>
        </>
    )
}

export default CommentList;